import gql from 'graphql-tag';
export const QUALIFICATION_CHECK_FORM_PAGE_DATA = gql`
  query ($applicationIdString: String!, $applicationId: ID!) {
    programmeChoiceMetadata {
      countryList {
        value
        label
      }
    }

    studentParticular(applicationId: $applicationIdString) {
      applicationNumber
      nameInEnglishSurname
      nameInEnglishGivenName
      nameInChinese
      gender
      dateOfBirth
      nationalityCountryRegion
      identityType
      identityNumber
      emailAddress
    }

    application(id: $applicationId) {
      academicQualifications {
        _id
        presentIndicator
        gpaIndicator
        rankIndicator
        academicCredentialIndicator
        degreeCertIndicator
        from
        to
        studyMode
        institution {
          country
          name
        }
        instructionMedium
        otherInstructionMedium
        currentStudyYear
        studyField
        degreeLevel
        qualificationMeans
        programmeName
        qualificationStatus
        academicOnlineVerificationCode
        degreeOnlineVerificationCode
        expectUpdateDate
        awardDate
        awardClassification
        withdrawDate
        officialClassRanking
        outOfRank
        officialMark
        outOfGpa
        convertGPARuleId
        marks {
          course
          credit
          result
        }
        markConversion {
          convertedMark
          letterToGPARule {
            name
          }
          digitToLetterRule {
            name
          }
        }

        certificates {
          id
          link
          name
        }

        transcripts {
          id
          link
          name
        }

        markExplanations {
          id
          link
          name
        }

        classRankProofs {
          id
          link
          name
        }

        otherDocuments {
          id
          link
          name
        }
      }
      languageQualifications {
        _id
        needEnglishTest
        testType
        testDate
        referenceNo
        expectedResultUpdateDate
        resultAnnouncedIndicator
        result {
          resultReceiptDate
          listening
          reading
          writing
          speaking
          overall
        }
        supportingDocuments {
          id
          link
          name
        }
      }
      otherTests {
        _id
        testType
        testDate
        expectedResultUpdateDate
        resultAnnouncedIndicator
        referenceNo
        result {
          totalScore
          totalPercentile
          quantitativeScore
          quantitativePercentile
          analyticalWritingScore
          analyticalWritingPercentile
          verbalScore
          verbalPercentile
          integratedReasoningScore
          integratedReasoningPercentile
          dataInsightsScore
          dataInsightsPercentile
        }
        supportingDocuments {
          id
          link
          name
        }
      }
    }

    qualificationCheck(applicationId: $applicationIdString) {
      status
      remark {
        remark
        at
        by
      }
      supportingDocuments {
        id
        link
        name
      }
      academicQualification {
        qualificationId
        academicCredentialCheckPassed
        degreeCertificationCheckPassed
        status
      }
      languageQualification {
        qualificationId
        status
      }
      otherTestQualification {
        qualificationId
        status
      }
    }
  }
`;
